
import { useEffect, useRef } from 'react';
import { Result } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

export default function GatewayRedirect() {
  const { propcode } = useParams<{ propcode: string }>()
  const formRef = useRef<HTMLFormElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
    //const t = setTimeout(() => formRef.current?.submit(), 800);
    //return () => clearTimeout(t);

    /* Mockup redirect by navigate */
     const t = setTimeout(() => navigate(`/booking/${propcode}/payment/result`), 800);
    return () => clearTimeout(t);

  }, []);



  return (
    <>
      <Result status="info" title="Redirecting to payment gateway..." />
      <form ref={formRef} action={`/booking/${propcode}/payment/result`} method="GET">
        <input type="hidden" name="status" value="success" />
      </form>
    </>
  );
}
